export const onboarding = {
  en: {
    // Guided First Quiz - Welcome
    welcomeTitle: 'Welcome to\nKingdom Bible Quiz',
    welcomeSubtitle: 'A daily return to God\'s Word',
    welcomeDescription: 'Let\'s discover how much you already know about the Bible. Ready for a quick quiz?',
    welcomeCTA: 'Let\'s Find Out',
    welcomeEyebrow: 'Scripture Adventure',
    statQuestions: 'Questions',
    statLanguages: 'Languages',
    statDaily: 'Daily',
    statJourney: 'Journey',

    // Guided First Quiz - Quiz Phase
    quizHeader: 'Your First Quiz',
    quizQuestion: 'Question {current} of {total}',

    // Guided First Quiz - Celebration
    celebrationTitle: 'Amazing!',
    celebrationSubtitle: 'You got {score} out of {total} right!',
    celebrationMessage: 'You already know more than you think. Imagine how much you\'ll discover with a few minutes each day.',
    celebrationInvite: 'Come back tomorrow and we\'ll go deeper.',
    celebrationCTA: 'Start Exploring',

    // Shared
    skip: 'Skip',
    progressIndicator: '{current} of {total}',
    getStarted: 'Get Started',
    loading: 'Preparing your quiz...',
    errorLoading: 'Couldn\'t load questions. Let\'s skip ahead!',

    // Legacy keys (kept for backward compatibility)
    screen1Title: 'Welcome to Kingdom Bible Quiz',
    screen1Subtitle: 'Test Your Bible Knowledge',
    screen1Description: 'Join millions of believers in the ultimate Bible quiz experience. Challenge yourself, learn scripture, and grow in faith.',
    screen1Feature1: '30,000+ Bible questions across all topics',
    screen1Feature2: 'Multiple difficulty levels for all ages',
    screen1Feature3: '10 languages supported worldwide',
    screen1CTA: 'Get Started',
    screen2Title: 'Play with Family & Friends',
    screen2Subtitle: 'Strengthen Bonds Through Faith',
    screen2Description: 'Create groups with your loved ones and compete in real-time Bible quizzes. Perfect for family devotions and friendly competitions.',
    screen2Feature1: 'Create family and friend groups',
    screen2Feature2: 'Real-time multiplayer gameplay',
    screen2Feature3: 'Private rooms for your circle',
    screen2CTA: 'Connect with Others',
    screen3Title: 'Church & Community Events',
    screen3Subtitle: 'Engage Your Congregation',
    screen3Description: 'Host live Bible quiz events for your church or community. Perfect for youth groups, Bible studies, and special events.',
    screen3Feature1: 'Host events for up to 500 participants',
    screen3Feature2: 'Projector mode for large screens',
    screen3Feature3: 'QR code joining for easy participation',
    screen3CTA: 'Host Events',
    screen4Title: 'Track Your Progress',
    screen4Subtitle: 'Grow in Knowledge',
    screen4Description: 'Monitor your Bible knowledge journey with detailed statistics, achievements, and personalized insights.',
    screen4Feature1: 'Personal progress tracking',
    screen4Feature2: 'Unlock achievements and badges',
    screen4Feature3: 'Compete on global leaderboards',
    screen4CTA: 'Start Learning',
    screen5Title: 'Ready to Begin?',
    screen5Subtitle: 'Your Bible Journey Starts Now',
    screen5Description: 'Join our community of believers and start your Bible quiz adventure. Choose your first challenge and let\'s begin!',
    screen5Feature1: 'Take your first quiz in under 2 minutes',
    screen5Feature2: 'Join a community of faithful learners',
    screen5Feature3: 'Discover new insights from Scripture',
    screen5CTA: 'Start My First Quiz',
  },
  es: {
    welcomeTitle: 'Bienvenido a\nKingdom Bible Quiz',
    welcomeSubtitle: 'Un regreso diario a la Palabra de Dios',
    welcomeDescription: 'Descubramos cuánto sabes ya sobre la Biblia. ¿Listo para un quiz rápido?',
    welcomeCTA: 'Descubramos',
    welcomeEyebrow: 'Aventura bíblica',
    statQuestions: 'Preguntas',
    statLanguages: 'Idiomas',
    statDaily: 'Diario',
    statJourney: 'Camino',
    quizHeader: 'Tu primer quiz',
    quizQuestion: 'Pregunta {current} de {total}',
    celebrationTitle: '¡Increíble!',
    celebrationSubtitle: '¡Acertaste {score} de {total}!',
    celebrationMessage: 'Ya sabes más de lo que crees. Imagina todo lo que descubrirás con unos minutos al día.',
    celebrationInvite: 'Vuelve mañana y profundizaremos más.',
    celebrationCTA: 'Empezar a explorar',
    skip: 'Saltar',
    progressIndicator: '{current} de {total}',
    getStarted: 'Empezar',
    loading: 'Preparando tu quiz...',
    errorLoading: 'No se pudieron cargar las preguntas. ¡Continuemos!',
    screen1Title: 'Bienvenido a Kingdom Bible Quiz',
    screen1Subtitle: 'Pon a prueba tu conocimiento bíblico',
    screen1Description: 'Únete a millones de creyentes en la experiencia definitiva de quiz bíblico. Desafíate, aprende las Escrituras y crece en la fe.',
    screen1Feature1: '30.000+ preguntas bíblicas en todos los temas',
    screen1Feature2: 'Múltiples niveles de dificultad para todas las edades',
    screen1Feature3: '10 idiomas disponibles en todo el mundo',
    screen1CTA: 'Comenzar',
    screen2Title: 'Juega con familia y amigos',
    screen2Subtitle: 'Fortalece los vínculos a través de la fe',
    screen2Description: 'Crea grupos con tus seres queridos y compite en quizzes bíblicos en tiempo real. Ideal para devocionales en familia y competencias amistosas.',
    screen2Feature1: 'Crea grupos de familia y amigos',
    screen2Feature2: 'Partidas multijugador en tiempo real',
    screen2Feature3: 'Salas privadas para tu círculo',
    screen2CTA: 'Conectar con otros',
    screen3Title: 'Eventos de iglesia y comunidad',
    screen3Subtitle: 'Involucra a tu congregación',
    screen3Description: 'Organiza quizzes bíblicos en vivo para tu iglesia o comunidad. Ideal para grupos de jóvenes, estudios bíblicos y eventos especiales.',
    screen3Feature1: 'Organiza eventos para hasta 500 participantes',
    screen3Feature2: 'Modo proyector para pantallas grandes',
    screen3Feature3: 'Únete fácilmente con un código QR',
    screen3CTA: 'Organizar eventos',
    screen4Title: 'Sigue tu progreso',
    screen4Subtitle: 'Crece en conocimiento',
    screen4Description: 'Sigue tu camino de conocimiento bíblico con estadísticas detalladas, logros y perspectivas personalizadas.',
    screen4Feature1: 'Seguimiento de tu progreso personal',
    screen4Feature2: 'Desbloquea logros e insignias',
    screen4Feature3: 'Compite en clasificaciones globales',
    screen4CTA: 'Empezar a aprender',
    screen5Title: '¿Listo para comenzar?',
    screen5Subtitle: 'Tu viaje bíblico empieza ahora',
    screen5Description: 'Únete a nuestra comunidad de creyentes y comienza tu aventura de quiz bíblico. ¡Elige tu primer desafío y empecemos!',
    screen5Feature1: 'Haz tu primer quiz en menos de 2 minutos',
    screen5Feature2: 'Únete a una comunidad de aprendices fieles',
    screen5Feature3: 'Descubre nuevas perspectivas de las Escrituras',
    screen5CTA: 'Comenzar mi primer quiz',
  },
  fr: {
    welcomeTitle: 'Bienvenue à\nKingdom Bible Quiz',
    welcomeSubtitle: 'Un retour quotidien à la Parole de Dieu',
    welcomeDescription: 'Découvrons ce que vous savez déjà sur la Bible. Prêt pour un petit quiz ?',
    welcomeCTA: 'Découvrons',
    welcomeEyebrow: 'Aventure biblique',
    statQuestions: 'Questions',
    statLanguages: 'Langues',
    statDaily: 'Quotidien',
    statJourney: 'Parcours',
    quizHeader: 'Votre premier quiz',
    quizQuestion: 'Question {current} sur {total}',
    celebrationTitle: 'Fantastique !',
    celebrationSubtitle: 'Vous avez eu {score} bonnes réponses sur {total} !',
    celebrationMessage: 'Vous en savez déjà plus que vous ne le pensez. Imaginez tout ce que vous découvrirez en quelques minutes par jour.',
    celebrationInvite: 'Revenez demain et nous irons plus loin.',
    celebrationCTA: 'Commencer à explorer',
    skip: 'Ignorer',
    progressIndicator: '{current} sur {total}',
    getStarted: 'Commencer',
    loading: 'Préparation de votre quiz...',
    errorLoading: 'Impossible de charger les questions. Continuons !',
    screen1Title: 'Bienvenue à Kingdom Bible Quiz',
    screen1Subtitle: 'Testez vos connaissances bibliques',
    screen1Description: 'Rejoignez des millions de croyants dans l\'expérience de quiz biblique ultime. Relevez le défi, apprenez les Écritures et grandissez dans la foi.',
    screen1Feature1: '30 000+ questions bibliques sur tous les sujets',
    screen1Feature2: 'Plusieurs niveaux de difficulté pour tous les âges',
    screen1Feature3: '10 langues disponibles dans le monde entier',
    screen1CTA: 'Commencer',
    screen2Title: 'Jouez en famille et entre amis',
    screen2Subtitle: 'Renforcez les liens par la foi',
    screen2Description: 'Créez des groupes avec vos proches et affrontez-vous dans des quiz bibliques en temps réel. Idéal pour les moments de dévotion en famille et les compétitions amicales.',
    screen2Feature1: 'Créez des groupes de famille et d\'amis',
    screen2Feature2: 'Parties multijoueurs en temps réel',
    screen2Feature3: 'Salons privés pour votre cercle',
    screen2CTA: 'Se connecter avec les autres',
    screen3Title: 'Événements d\'église et de communauté',
    screen3Subtitle: 'Impliquez votre assemblée',
    screen3Description: 'Organisez des quiz bibliques en direct pour votre église ou votre communauté. Idéal pour les groupes de jeunes, les études bibliques et les événements spéciaux.',
    screen3Feature1: 'Organisez des événements jusqu\'à 500 participants',
    screen3Feature2: 'Mode projecteur pour grands écrans',
    screen3Feature3: 'Rejoignez facilement avec un code QR',
    screen3CTA: 'Organiser des événements',
    screen4Title: 'Suivez votre progression',
    screen4Subtitle: 'Grandissez en connaissance',
    screen4Description: 'Suivez votre parcours de connaissance biblique avec des statistiques détaillées, des succès et des analyses personnalisées.',
    screen4Feature1: 'Suivi de votre progression personnelle',
    screen4Feature2: 'Débloquez des succès et des badges',
    screen4Feature3: 'Affrontez-vous dans des classements mondiaux',
    screen4CTA: 'Commencer à apprendre',
    screen5Title: 'Prêt à commencer ?',
    screen5Subtitle: 'Votre voyage biblique commence maintenant',
    screen5Description: 'Rejoignez notre communauté de croyants et commencez votre aventure de quiz biblique. Choisissez votre premier défi et c\'est parti !',
    screen5Feature1: 'Faites votre premier quiz en moins de 2 minutes',
    screen5Feature2: 'Rejoignez une communauté d\'apprenants fidèles',
    screen5Feature3: 'Découvrez de nouvelles perspectives des Écritures',
    screen5CTA: 'Commencer mon premier quiz',
  },
  de: {
    welcomeTitle: 'Willkommen bei\nKingdom Bible Quiz',
    welcomeSubtitle: 'Eine tägliche Rückkehr zu Gottes Wort',
    welcomeDescription: 'Finden wir heraus, wie viel du schon über die Bibel weißt. Bereit für ein kurzes Quiz?',
    welcomeCTA: 'Finden wir es heraus',
    welcomeEyebrow: 'Bibel-Abenteuer',
    statQuestions: 'Fragen',
    statLanguages: 'Sprachen',
    statDaily: 'Täglich',
    statJourney: 'Reise',
    quizHeader: 'Dein erstes Quiz',
    quizQuestion: 'Frage {current} von {total}',
    celebrationTitle: 'Erstaunlich!',
    celebrationSubtitle: 'Du hast {score} von {total} richtig!',
    celebrationMessage: 'Du weißt schon mehr, als du denkst. Stell dir vor, was du mit ein paar Minuten täglich entdeckst.',
    celebrationInvite: 'Komm morgen wieder und wir gehen tiefer.',
    celebrationCTA: 'Jetzt entdecken',
    skip: 'Überspringen',
    progressIndicator: '{current} von {total}',
    getStarted: 'Loslegen',
    loading: 'Quiz wird vorbereitet...',
    errorLoading: 'Fragen konnten nicht geladen werden. Machen wir weiter!',
    screen1Title: 'Willkommen bei Kingdom Bible Quiz',
    screen1Subtitle: 'Teste dein Bibelwissen',
    screen1Description: 'Schließe dich Millionen von Gläubigen im ultimativen Bibel-Quiz-Erlebnis an. Fordere dich heraus, lerne die Schrift und wachse im Glauben.',
    screen1Feature1: '30.000+ Bibelfragen zu allen Themen',
    screen1Feature2: 'Mehrere Schwierigkeitsstufen für alle Altersgruppen',
    screen1Feature3: '10 Sprachen weltweit verfügbar',
    screen1CTA: 'Loslegen',
    screen2Title: 'Spiele mit Familie und Freunden',
    screen2Subtitle: 'Stärke Bindungen durch den Glauben',
    screen2Description: 'Erstelle Gruppen mit deinen Liebsten und tritt in Echtzeit-Bibelquiz gegeneinander an. Perfekt für Familienandachten und freundschaftliche Wettbewerbe.',
    screen2Feature1: 'Erstelle Familien- und Freundesgruppen',
    screen2Feature2: 'Echtzeit-Mehrspielermodus',
    screen2Feature3: 'Private Räume für deinen Kreis',
    screen2CTA: 'Mit anderen verbinden',
    screen3Title: 'Kirchen- und Gemeindeveranstaltungen',
    screen3Subtitle: 'Begeistere deine Gemeinde',
    screen3Description: 'Veranstalte Live-Bibelquiz für deine Kirche oder Gemeinde. Perfekt für Jugendgruppen, Bibelstudien und besondere Anlässe.',
    screen3Feature1: 'Veranstaltungen für bis zu 500 Teilnehmende',
    screen3Feature2: 'Projektormodus für große Bildschirme',
    screen3Feature3: 'Einfach per QR-Code beitreten',
    screen3CTA: 'Events veranstalten',
    screen4Title: 'Verfolge deinen Fortschritt',
    screen4Subtitle: 'Wachse im Wissen',
    screen4Description: 'Behalte deine Reise durch das Bibelwissen im Blick – mit detaillierten Statistiken, Erfolgen und persönlichen Einblicken.',
    screen4Feature1: 'Persönliche Fortschrittsverfolgung',
    screen4Feature2: 'Schalte Erfolge und Abzeichen frei',
    screen4Feature3: 'Tritt in globalen Bestenlisten an',
    screen4CTA: 'Lernen beginnen',
    screen5Title: 'Bereit zu beginnen?',
    screen5Subtitle: 'Deine Bibelreise beginnt jetzt',
    screen5Description: 'Werde Teil unserer Gemeinschaft von Gläubigen und starte dein Bibelquiz-Abenteuer. Wähle deine erste Herausforderung und los geht\'s!',
    screen5Feature1: 'Mache dein erstes Quiz in unter 2 Minuten',
    screen5Feature2: 'Schließe dich einer Gemeinschaft treuer Lernender an',
    screen5Feature3: 'Entdecke neue Einsichten aus der Schrift',
    screen5CTA: 'Mein erstes Quiz starten',
  },
  pt: {
    welcomeTitle: 'Bem-vindo ao\nKingdom Bible Quiz',
    welcomeSubtitle: 'Um retorno diário à Palavra de Deus',
    welcomeDescription: 'Vamos descobrir o quanto você já sabe sobre a Bíblia. Pronto para um quiz rápido?',
    welcomeCTA: 'Vamos descobrir',
    welcomeEyebrow: 'Aventura bíblica',
    statQuestions: 'Perguntas',
    statLanguages: 'Idiomas',
    statDaily: 'Diário',
    statJourney: 'Jornada',
    quizHeader: 'Seu primeiro quiz',
    quizQuestion: 'Pergunta {current} de {total}',
    celebrationTitle: 'Incrível!',
    celebrationSubtitle: 'Você acertou {score} de {total}!',
    celebrationMessage: 'Você já sabe mais do que imagina. Pense em tudo o que vai descobrir com alguns minutos por dia.',
    celebrationInvite: 'Volte amanhã e vamos aprofundar mais.',
    celebrationCTA: 'Começar a explorar',
    skip: 'Pular',
    progressIndicator: '{current} de {total}',
    getStarted: 'Começar',
    loading: 'Preparando seu quiz...',
    errorLoading: 'Não foi possível carregar as perguntas. Vamos continuar!',
    screen1Title: 'Bem-vindo ao Kingdom Bible Quiz',
    screen1Subtitle: 'Teste seu conhecimento bíblico',
    screen1Description: 'Junte-se a milhões de crentes na experiência definitiva de quiz bíblico. Desafie-se, aprenda as Escrituras e cresça na fé.',
    screen1Feature1: '30.000+ perguntas bíblicas sobre todos os temas',
    screen1Feature2: 'Vários níveis de dificuldade para todas as idades',
    screen1Feature3: '10 idiomas disponíveis no mundo todo',
    screen1CTA: 'Começar',
    screen2Title: 'Jogue com família e amigos',
    screen2Subtitle: 'Fortaleça os vínculos através da fé',
    screen2Description: 'Crie grupos com seus entes queridos e dispute quizzes bíblicos em tempo real. Perfeito para devocionais em família e competições amigáveis.',
    screen2Feature1: 'Crie grupos de família e amigos',
    screen2Feature2: 'Partidas multijogador em tempo real',
    screen2Feature3: 'Salas privadas para o seu círculo',
    screen2CTA: 'Conectar com outros',
    screen3Title: 'Eventos de igreja e comunidade',
    screen3Subtitle: 'Envolva sua congregação',
    screen3Description: 'Realize quizzes bíblicos ao vivo para sua igreja ou comunidade. Perfeito para grupos de jovens, estudos bíblicos e eventos especiais.',
    screen3Feature1: 'Realize eventos para até 500 participantes',
    screen3Feature2: 'Modo projetor para telas grandes',
    screen3Feature3: 'Entre facilmente com um código QR',
    screen3CTA: 'Organizar eventos',
    screen4Title: 'Acompanhe seu progresso',
    screen4Subtitle: 'Cresça em conhecimento',
    screen4Description: 'Acompanhe sua jornada de conhecimento bíblico com estatísticas detalhadas, conquistas e insights personalizados.',
    screen4Feature1: 'Acompanhamento do progresso pessoal',
    screen4Feature2: 'Desbloqueie conquistas e emblemas',
    screen4Feature3: 'Dispute em rankings globais',
    screen4CTA: 'Começar a aprender',
    screen5Title: 'Pronto para começar?',
    screen5Subtitle: 'Sua jornada bíblica começa agora',
    screen5Description: 'Junte-se à nossa comunidade de crentes e comece sua aventura de quiz bíblico. Escolha seu primeiro desafio e vamos lá!',
    screen5Feature1: 'Faça seu primeiro quiz em menos de 2 minutos',
    screen5Feature2: 'Junte-se a uma comunidade de aprendizes fiéis',
    screen5Feature3: 'Descubra novas perspectivas das Escrituras',
    screen5CTA: 'Começar meu primeiro quiz',
  },
  ru: {
    welcomeTitle: 'Добро пожаловать\nв Kingdom Bible Quiz',
    welcomeSubtitle: 'Ежедневное возвращение к Слову Божьему',
    welcomeDescription: 'Давайте узнаем, сколько вы уже знаете о Библии. Готовы к быстрой викторине?',
    welcomeCTA: 'Давайте узнаем',
    welcomeEyebrow: 'Библейское приключение',
    statQuestions: 'Вопросов',
    statLanguages: 'Языков',
    statDaily: 'Ежедневно',
    statJourney: 'Путь',
    quizHeader: 'Ваша первая викторина',
    quizQuestion: 'Вопрос {current} из {total}',
    celebrationTitle: 'Потрясающе!',
    celebrationSubtitle: 'Вы правильно ответили на {score} из {total}!',
    celebrationMessage: 'Вы уже знаете больше, чем думаете. Представьте, сколько всего вы откроете, уделяя несколько минут в день.',
    celebrationInvite: 'Возвращайтесь завтра — и мы пойдём глубже.',
    celebrationCTA: 'Начать исследовать',
    skip: 'Пропустить',
    progressIndicator: '{current} из {total}',
    getStarted: 'Начать',
    loading: 'Подготовка викторины...',
    errorLoading: 'Не удалось загрузить вопросы. Продолжим!',
    screen1Title: 'Добро пожаловать в Kingdom Bible Quiz',
    screen1Subtitle: 'Проверьте свои знания Библии',
    screen1Description: 'Присоединяйтесь к миллионам верующих в лучшей библейской викторине. Бросьте себе вызов, изучайте Писание и растите в вере.',
    screen1Feature1: '30 000+ библейских вопросов по всем темам',
    screen1Feature2: 'Несколько уровней сложности для любого возраста',
    screen1Feature3: '10 языков по всему миру',
    screen1CTA: 'Начать',
    screen2Title: 'Играйте с семьёй и друзьями',
    screen2Subtitle: 'Укрепляйте связи через веру',
    screen2Description: 'Создавайте группы с близкими и соревнуйтесь в библейских викторинах в реальном времени. Отлично подходит для семейных чтений и дружеских состязаний.',
    screen2Feature1: 'Создавайте семейные и дружеские группы',
    screen2Feature2: 'Многопользовательская игра в реальном времени',
    screen2Feature3: 'Закрытые комнаты для вашего круга',
    screen2CTA: 'Общаться с другими',
    screen3Title: 'События церкви и общины',
    screen3Subtitle: 'Вовлекайте вашу общину',
    screen3Description: 'Проводите библейские викторины в прямом эфире для вашей церкви или общины. Отлично подходит для молодёжных групп, изучения Библии и особых событий.',
    screen3Feature1: 'Мероприятия для до 500 участников',
    screen3Feature2: 'Режим проектора для больших экранов',
    screen3Feature3: 'Простое подключение по QR-коду',
    screen3CTA: 'Проводить мероприятия',
    screen4Title: 'Отслеживайте свой прогресс',
    screen4Subtitle: 'Растите в знаниях',
    screen4Description: 'Следите за своим путём в изучении Библии: подробная статистика, достижения и персональные подсказки.',
    screen4Feature1: 'Отслеживание личного прогресса',
    screen4Feature2: 'Открывайте достижения и значки',
    screen4Feature3: 'Соревнуйтесь в мировых рейтингах',
    screen4CTA: 'Начать учиться',
    screen5Title: 'Готовы начать?',
    screen5Subtitle: 'Ваш библейский путь начинается сейчас',
    screen5Description: 'Присоединяйтесь к нашему сообществу верующих и начните своё приключение в библейской викторине. Выберите первое испытание — и начнём!',
    screen5Feature1: 'Пройдите первую викторину меньше чем за 2 минуты',
    screen5Feature2: 'Присоединяйтесь к сообществу верных учеников',
    screen5Feature3: 'Открывайте для себя новое в Писании',
    screen5CTA: 'Начать мою первую викторину',
  },
  tl: {
    welcomeTitle: 'Maligayang pagdating sa\nKingdom Bible Quiz',
    welcomeSubtitle: 'Araw-araw na pagbabalik sa Salita ng Diyos',
    welcomeDescription: 'Alamin natin kung gaano na karami ang alam mo tungkol sa Bibliya. Handa ka na ba sa isang mabilis na quiz?',
    welcomeCTA: 'Alamin Natin',
    welcomeEyebrow: 'Pakikipagsapalaran sa Bibliya',
    statQuestions: 'Mga tanong',
    statLanguages: 'Mga wika',
    statDaily: 'Araw-araw',
    statJourney: 'Paglalakbay',
    quizHeader: 'Ang Iyong Unang Quiz',
    quizQuestion: 'Tanong {current} ng {total}',
    celebrationTitle: 'Kahanga-hanga!',
    celebrationSubtitle: 'Nakuha mo ang {score} sa {total}!',
    celebrationMessage: 'Mas marami ka nang alam kaysa sa akala mo. Isipin mo kung gaano karami ang matututunan mo sa ilang minuto bawat araw.',
    celebrationInvite: 'Bumalik bukas at laliman pa natin.',
    celebrationCTA: 'Magsimulang Mag-explore',
    skip: 'Laktawan',
    progressIndicator: '{current} ng {total}',
    getStarted: 'Magsimula',
    loading: 'Inihahanda ang iyong quiz...',
    errorLoading: 'Hindi ma-load ang mga tanong. Magpatuloy tayo!',
    screen1Title: 'Maligayang pagdating sa Kingdom Bible Quiz',
    screen1Subtitle: 'Subukan ang Inyong Kaalaman sa Bibliya',
    screen1Description: 'Makipagsama sa milyun-milyong mga mananampalataya sa pinakamahalagang karanasan ng Bible quiz.',
    screen1Feature1: '30,000+ mga tanong sa Bibliya sa lahat ng paksa',
    screen1Feature2: 'Maraming antas ng kahirapan para sa lahat ng edad',
    screen1Feature3: '10 wika na sinusuportahan sa buong mundo',
    screen1CTA: 'Magsimula',
    screen2Title: 'Maglaro kasama ang Pamilya at mga Kaibigan',
    screen2Subtitle: 'Palakasin ang mga Ugnayan sa Pamamagitan ng Pananampalataya',
    screen2Description: 'Lumikha ng mga grupo kasama ang inyong mga mahal sa buhay at makipagkumpitensya sa real-time Bible quizzes.',
    screen2Feature1: 'Lumikha ng mga grupo ng pamilya at kaibigan',
    screen2Feature2: 'Real-time multiplayer gameplay',
    screen2Feature3: 'Mga pribadong silid para sa inyong grupo',
    screen2CTA: 'Makipag-ugnayan sa Iba',
    screen3Title: 'Mga Kaganapan ng Simbahan at Komunidad',
    screen3Subtitle: 'Makipag-ugnayan sa Inyong Kongregasyon',
    screen3Description: 'Mag-host ng live Bible quiz events para sa inyong simbahan o komunidad.',
    screen3Feature1: 'Mag-host ng mga kaganapan para sa hanggang 500 kalahok',
    screen3Feature2: 'Projector mode para sa malalaking screen',
    screen3Feature3: 'QR code joining para sa madaling pakikilahok',
    screen3CTA: 'Mag-host ng mga Kaganapan',
    screen4Title: 'Subaybayan ang Inyong Pag-unlad',
    screen4Subtitle: 'Lumago sa Kaalaman',
    screen4Description: 'Bantayan ang inyong paglalakbay sa kaalaman ng Bibliya gamit ang detalyadong statistics.',
    screen4Feature1: 'Personal progress tracking',
    screen4Feature2: 'I-unlock ang mga achievements at badges',
    screen4Feature3: 'Makipagkumpitensya sa global leaderboards',
    screen4CTA: 'Magsimulang Matuto',
    screen5Title: 'Handa na bang Magsimula?',
    screen5Subtitle: 'Ang Inyong Bible Journey ay Nagsisimula Ngayon',
    screen5Description: 'Makipagsama sa aming komunidad ng mga mananampalataya at simulan ang inyong Bible quiz adventure.',
    screen5Feature1: 'Kunin ang inyong unang quiz sa loob ng 2 minuto',
    screen5Feature2: 'Makipagsama sa komunidad ng mga tapat na nag-aaral',
    screen5Feature3: 'Tuklasin ang mga bagong insight mula sa Kasulatan',
    screen5CTA: 'Simulan ang Aking Unang Quiz',
  },
  it: {
    welcomeTitle: 'Benvenuto in\nKingdom Bible Quiz',
    welcomeSubtitle: 'Un ritorno quotidiano alla Parola di Dio',
    welcomeDescription: 'Scopriamo quanto sai già sulla Bibbia. Pronto per un quiz veloce?',
    welcomeCTA: 'Scopriamolo',
    welcomeEyebrow: 'Avventura biblica',
    statQuestions: 'Domande',
    statLanguages: 'Lingue',
    statDaily: 'Quotidiano',
    statJourney: 'Percorso',
    quizHeader: 'Il tuo primo quiz',
    quizQuestion: 'Domanda {current} di {total}',
    celebrationTitle: 'Fantastico!',
    celebrationSubtitle: 'Hai indovinato {score} su {total}!',
    celebrationMessage: 'Sai già più di quanto pensi. Immagina quanto scoprirai con pochi minuti al giorno.',
    celebrationInvite: 'Torna domani e andremo più a fondo.',
    celebrationCTA: 'Inizia a esplorare',
    skip: 'Salta',
    progressIndicator: '{current} di {total}',
    getStarted: 'Inizia',
    loading: 'Preparazione del quiz...',
    errorLoading: 'Impossibile caricare le domande. Andiamo avanti!',
    screen1Title: 'Benvenuto in Kingdom Bible Quiz',
    screen1Subtitle: 'Metti alla prova la tua conoscenza biblica',
    screen1Description: 'Unisciti a milioni di credenti nell\'esperienza di quiz biblico definitiva. Mettiti alla prova, impara le Scritture e cresci nella fede.',
    screen1Feature1: '30.000+ domande bibliche su tutti gli argomenti',
    screen1Feature2: 'Più livelli di difficoltà per tutte le età',
    screen1Feature3: '10 lingue disponibili in tutto il mondo',
    screen1CTA: 'Inizia',
    screen2Title: 'Gioca con famiglia e amici',
    screen2Subtitle: 'Rafforza i legami attraverso la fede',
    screen2Description: 'Crea gruppi con i tuoi cari e sfidatevi in quiz biblici in tempo reale. Perfetto per le devozioni in famiglia e le sfide amichevoli.',
    screen2Feature1: 'Crea gruppi di famiglia e amici',
    screen2Feature2: 'Partite multigiocatore in tempo reale',
    screen2Feature3: 'Stanze private per la tua cerchia',
    screen2CTA: 'Connettiti con gli altri',
    screen3Title: 'Eventi di chiesa e comunità',
    screen3Subtitle: 'Coinvolgi la tua congregazione',
    screen3Description: 'Organizza quiz biblici dal vivo per la tua chiesa o comunità. Perfetto per gruppi giovanili, studi biblici ed eventi speciali.',
    screen3Feature1: 'Organizza eventi fino a 500 partecipanti',
    screen3Feature2: 'Modalità proiettore per schermi grandi',
    screen3Feature3: 'Partecipa facilmente con un codice QR',
    screen3CTA: 'Organizza eventi',
    screen4Title: 'Traccia i tuoi progressi',
    screen4Subtitle: 'Cresci nella conoscenza',
    screen4Description: 'Segui il tuo percorso di conoscenza biblica con statistiche dettagliate, traguardi e approfondimenti personalizzati.',
    screen4Feature1: 'Monitoraggio dei progressi personali',
    screen4Feature2: 'Sblocca traguardi e distintivi',
    screen4Feature3: 'Competi nelle classifiche globali',
    screen4CTA: 'Inizia a imparare',
    screen5Title: 'Pronto a iniziare?',
    screen5Subtitle: 'Il tuo viaggio biblico inizia ora',
    screen5Description: 'Unisciti alla nostra comunità di credenti e inizia la tua avventura di quiz biblico. Scegli la tua prima sfida e cominciamo!',
    screen5Feature1: 'Fai il tuo primo quiz in meno di 2 minuti',
    screen5Feature2: 'Unisciti a una comunità di studenti fedeli',
    screen5Feature3: 'Scopri nuove prospettive dalle Scritture',
    screen5CTA: 'Inizia il mio primo quiz',
  },
  am: {
    welcomeTitle: 'ወደ Kingdom Bible Quiz\nእንኳን በደህና መጡ',
    welcomeSubtitle: 'ወደ እግዚአብሔር ቃል ዕለታዊ መመለስ',
    welcomeDescription: 'ስለ መጽሐፍ ቅዱስ ምን ያህል እንደሚያውቁ እንወቅ። ለፈጣን ክዊዝ ዝግጁ ነዎት?',
    welcomeCTA: 'እንወቅ',
    welcomeEyebrow: 'የመጽሐፍ ቅዱስ ጀብዱ',
    statQuestions: 'ጥያቄዎች',
    statLanguages: 'ቋንቋዎች',
    statDaily: 'በየቀኑ',
    statJourney: 'ጉዞ',
    quizHeader: 'የመጀመሪያ ክዊዝዎ',
    quizQuestion: 'ጥያቄ {current} ከ {total}',
    celebrationTitle: 'አስደናቂ!',
    celebrationSubtitle: 'ከ{total} ውስጥ {score} አግኝተዋል!',
    celebrationMessage: 'ከሚያስቡት በላይ ያውቃሉ። በቀን ጥቂት ደቂቃዎች ምን ያህል እንደሚያገኙ ያስቡ።',
    celebrationInvite: 'ነገ ተመለሱ እና ጥልቅ እንሄዳለን።',
    celebrationCTA: 'ማሰስ ይጀምሩ',
    skip: 'ዝለል',
    progressIndicator: '{current} ከ {total}',
    getStarted: 'ጀምር',
    loading: 'ክዊዝዎን በማዘጋጀት ላይ...',
    errorLoading: 'ጥያቄዎችን መጫን አልተቻለም። እንቀጥል!',
    screen1Title: 'ወደ Kingdom Bible Quiz እንኳን በደህና መጡ',
    screen1Subtitle: 'የእርስዎን የመጽሐፍ ቅዱስ እውቀት ይሞክሩ',
    screen1Description: 'በመጽሐፍ ቅዱስ ክዊዝ ልምድ ውስጥ ከሚሊዮን የሚቆጠሩ አማኞች ጋር ይቀላቀሉ።',
    screen1Feature1: '30,000+ የመጽሐፍ ቅዱስ ጥያቄዎች በሁሉም ርዕሶች ላይ',
    screen1Feature2: 'ለሁሉም እድሜዎች የተለያዩ ከባድነት ደረጃዎች',
    screen1Feature3: '10 ቋንቋዎች በዓለም ዙሪያ ይደገፋሉ',
    screen1CTA: 'ጀምር',
    screen2Title: 'ከቤተሰብ እና ጓደኞች ጋር ይጫወቱ',
    screen2Subtitle: 'በእምነት ትስስርን ያጠናክሩ',
    screen2Description: 'ከተወዳጆችዎ ጋር ቡድኖችን ይፍጠሩ እና በእውነተኛ ጊዜ የመጽሐፍ ቅዱስ ክዊዞች ውስጥ ይወዳደሩ።',
    screen2Feature1: 'የቤተሰብ እና ጓደኞች ቡድኖችን ይፍጠሩ',
    screen2Feature2: 'በእውነተኛ ጊዜ ብዙ ተጫዋች ጨዋታ',
    screen2Feature3: 'ለእርስዎ ክበብ የግል ክፍሎች',
    screen2CTA: 'ከሌሎች ጋር ይገናኙ',
    screen3Title: 'የቤተክርስቲያን እና የማህበረሰብ ዝግጅቶች',
    screen3Subtitle: 'ጉባኤዎን ያሳትፉ',
    screen3Description: 'ለቤተክርስቲያንዎ ወይም ማህበረሰብዎ የቀጥታ የመጽሐፍ ቅዱስ ክዊዝ ዝግጅቶችን ያስተናግዱ።',
    screen3Feature1: 'እስከ 500 ተሳታፊዎች ዝግጅቶችን ያስተናግዱ',
    screen3Feature2: 'ለትላልቅ ስክሪኖች የፕሮጄክተር ሁነታ',
    screen3Feature3: 'ለቀላል ተሳትፎ የQR ኮድ መቀላቀል',
    screen3CTA: 'ዝግጅቶችን አስተናግድ',
    screen4Title: 'እድገትዎን ይከታተሉ',
    screen4Subtitle: 'በእውቀት ያድጉ',
    screen4Description: 'የመጽሐፍ ቅዱስ እውቀት ጉዞዎን በዝርዝር ስታቲስቲክስ ይከታተሉ።',
    screen4Feature1: 'የግል እድገት ክትትል',
    screen4Feature2: 'ስኬቶችን እና ባጅዎችን ይክፈቱ',
    screen4Feature3: 'በዓለም አቀፍ ሊደርቦርዶች ይወዳደሩ',
    screen4CTA: 'መማር ጀምር',
    screen5Title: 'ለመጀመር ዝግጁ ነዎት?',
    screen5Subtitle: 'የእርስዎ የመጽሐፍ ቅዱስ ጉዞ አሁን ይጀምራል',
    screen5Description: 'ከአማኞች ማህበረሰባችን ጋር ይቀላቀሉ እና የመጽሐፍ ቅዱስ ክዊዝ ጀብዱዎን ይጀምሩ።',
    screen5Feature1: 'የመጀመሪያ ክዊዞዎን በ2 ደቂቃ ውስጥ ይውሰዱ',
    screen5Feature2: 'ከታማኝ ተማሪዎች ማህበረሰብ ጋር ይቀላቀሉ',
    screen5Feature3: 'ከመጽሐፍ ቅዱስ አዳዲስ ግንዛቤዎችን ያግኙ',
    screen5CTA: 'የመጀመሪያ ክዊዞን ጀምር',
  },
  ko: {
    welcomeTitle: 'Kingdom Bible Quiz에\n어서 오세요',
    welcomeSubtitle: '하나님의 말씀으로의 매일의 귀환',
    welcomeDescription: '성경에 대해 얼마나 알고 있는지 알아봅시다. 빠른 퀴즈 준비되셨나요?',
    welcomeCTA: '알아봅시다',
    welcomeEyebrow: '성경 어드벤처',
    statQuestions: '질문',
    statLanguages: '언어',
    statDaily: '매일',
    statJourney: '여정',
    quizHeader: '첫 번째 퀴즈',
    quizQuestion: '{total} 중 {current}번째 질문',
    celebrationTitle: '놀라워요!',
    celebrationSubtitle: '{total} 중 {score}개를 맞추셨습니다!',
    celebrationMessage: '생각보다 더 많이 알고 계시네요. 매일 몇 분으로 얼마나 많이 발견할 수 있을지 상상해보세요.',
    celebrationInvite: '내일 다시 오시면 더 깊이 들어갑니다.',
    celebrationCTA: '탐험 시작하기',
    skip: '건너뛰기',
    progressIndicator: '{total} 중 {current}',
    getStarted: '시작하기',
    loading: '퀴즈를 준비하고 있습니다...',
    errorLoading: '질문을 불러올 수 없습니다. 계속 진행합시다!',
    screen1Title: 'Kingdom Bible Quiz에 오신 것을 환영합니다',
    screen1Subtitle: '성경 지식을 테스트하세요',
    screen1Description: '궁극적인 성경 퀴즈 경험에서 수백만 명의 신자들과 함께하세요.',
    screen1Feature1: '모든 주제에 걸친 30,000개 이상의 성경 질문',
    screen1Feature2: '모든 연령을 위한 다양한 난이도 레벨',
    screen1Feature3: '전 세계 10개 언어 지원',
    screen1CTA: '시작하기',
    screen2Title: '가족과 친구들과 함께 플레이',
    screen2Subtitle: '믿음을 통해 유대감 강화',
    screen2Description: '사랑하는 사람들과 그룹을 만들고 실시간 성경 퀴즈에서 경쟁하세요.',
    screen2Feature1: '가족 및 친구 그룹 생성',
    screen2Feature2: '실시간 멀티플레이어 게임플레이',
    screen2Feature3: '당신의 서클을 위한 프라이빗 룸',
    screen2CTA: '다른 사람들과 연결',
    screen3Title: '교회 및 커뮤니티 이벤트',
    screen3Subtitle: '교인들을 참여시키세요',
    screen3Description: '교회나 커뮤니티를 위한 라이브 성경 퀴즈 이벤트를 개최하세요.',
    screen3Feature1: '최대 500명 참가자를 위한 이벤트 개최',
    screen3Feature2: '대형 스크린을 위한 프로젝터 모드',
    screen3Feature3: '쉬운 참여를 위한 QR 코드 참가',
    screen3CTA: '이벤트 개최',
    screen4Title: '진행 상황 추적',
    screen4Subtitle: '지식에서 성장',
    screen4Description: '상세한 통계, 업적 및 개인화된 인사이트로 성경 지식 여정을 모니터링하세요.',
    screen4Feature1: '개인 진행 상황 추적',
    screen4Feature2: '업적과 배지 잠금 해제',
    screen4Feature3: '글로벌 리더보드에서 경쟁',
    screen4CTA: '학습 시작',
    screen5Title: '시작할 준비가 되셨나요?',
    screen5Subtitle: '당신의 성경 여정이 지금 시작됩니다',
    screen5Description: '신자들의 커뮤니티에 참여하고 성경 퀴즈 모험을 시작하세요.',
    screen5Feature1: '2분 이내에 첫 번째 퀴즈 시작',
    screen5Feature2: '충실한 학습자들의 커뮤니티에 참여',
    screen5Feature3: '성경에서 새로운 통찰력 발견',
    screen5CTA: '첫 번째 퀴즈 시작',
  },
};
